import { useState } from 'react';
import { Customer, Order } from '../portals/admin/types';

export const useCustomers = () => {
  const [customers, setCustomers] = useState<Customer[]>([]);
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerOrders, setCustomerOrders] = useState<Order[]>([]);

  const loadCustomers = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch('/api/admin/customers', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setCustomers(data.customers || []);
      }
    } catch (error) {
      console.error('Failed to load customers:', error);
    }
  };

  const loadCustomerDetails = async (customerId: string) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/customers/${customerId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSelectedCustomer(data.customer);
        setCustomerOrders(data.orders || []);
        setShowCustomerModal(true);
      }
    } catch (error) {
      console.error('Failed to load customer details:', error);
    }
  };

  const viewCustomerDashboard = async (customerId: string) => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`/api/admin/customers/${customerId}/dashboard-view`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        // Return data for display in modal or new view
        return data;
      }
    } catch (error) {
      console.error('Failed to load customer dashboard view:', error);
    }
  };

  const closeCustomerModal = () => {
    setSelectedCustomer(null);
    setShowCustomerModal(false);
    setCustomerOrders([]);
  };

  return {
    customers,
    selectedCustomer,
    showCustomerModal,
    customerOrders,
    loadCustomers,
    loadCustomerDetails,
    viewCustomerDashboard,
    closeCustomerModal,
    setShowCustomerModal
  };
};
